import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'emailToDisplayValue',
    standalone: false
})
export class EmailToDisplayValuePipe implements PipeTransform {
    transform(value: any): string {
        if (value) {
            return `<a href="mailto:${value}">${value}</a>`;
        }
        return '';
    }
}